"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoJumper = void 0;
const events_1 = require("events");
const autoJumper_1 = require("./autoJumper");
const utils_1 = require("./utils");
class AutoJumper extends events_1.EventEmitter {
    bot;
    handler;
    lastJump = false;
    _enabled = false;
    cancelOnShift = false;
    get enabled() {
        return this._enabled;
    }
    set enabled(enable) {
        if (enable === this._enabled)
            return;
        if (enable)
            this.bot.on("physicsTick", this.jumpListener);
        else
            this.bot.off("physicsTick", this.jumpListener);
        this._enabled = enable;
    }
    constructor(bot, opts = {}) {
        super();
        this.bot = bot;
        this.handler = new autoJumper_1.JumpChecker(bot);
        this.setOpts(Object.assign({}, utils_1.DefaultKeys, opts));
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    /**
     * Set options straight to the class, inducing setters.
     * @param opts Options.
     */
    setOpts(opts) {
        for (const key in opts) {
            if (key in this && key in utils_1.DefaultKeys) {
                // @ts-expect-error
                this[key] = opts[key];
            }
            if (key in this.handler && key in utils_1.DefaultHandlerKeys) {
                // @ts-expect-error
                this.handler[key] = opts[key];
            }
        }
    }
    shouldJump() {
        return this.handler.shouldJump();
    }
    canJump() {
        return this.handler.canJump();
    }
    jumpListener = () => {
        if (this.cancelOnShift && this.bot.getControlState("sneak")) {
            this.lastJump = false;
            return;
        }
        if (this.handler.shouldJump()) {
            if (!this.lastJump) {
                this.emit("shouldJump");
                this.lastJump = true;
            }
            this.bot.setControlState("jump", true);
            this.bot.setControlState("jump", false);
        }
        else {
            if (this.lastJump) {
                this.lastJump = false;
            }
        }
    };
}
exports.AutoJumper = AutoJumper;
